import { createSlice } from '@reduxjs/toolkit';

const siteFeaturesSlice = createSlice({
  name: 'siteFeatures',
  initialState: {
    sidebarOpen: false,
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
  },
});

export const { toggleSidebar } = siteFeaturesSlice.actions;
export default siteFeaturesSlice.reducer;